import { COUNTRIES } from "@/constants/countries";

export const isValidPlateForCountry = (
  country: string,
  plate: string,
): boolean => {
  const countryData = COUNTRIES.find((c) => c.value === country);
  const regexes = countryData?.vehiclePlateRegexes;
  if (!regexes || Object.keys(regexes).length === 0) {
    return true;
  }
  return Object.values(regexes).some((regex) => regex.test(plate));
};
